import React from 'react';
import { Edit3, Zap, FileText, MapPin } from 'lucide-react';
const tomos = [{
  title: 'TOMO 1 · M6 y M7 (Parte 1)',
  desc: 'El primer contacto con el rugby. Juegos de iniciación, pelota y movimiento. 52 semanas de actividades listas para usar.'
}, {
  title: 'TOMO 2 · M6 y M7 (Parte 2)',
  desc: 'Consolidación del juego básico. Pase, apoyo y mini partido evaluatorio. Cierre anual y preparación para M8.'
}, {
  title: 'TOMO 3 · M8 a M12 (Parte 1)',
  desc: 'Infantil Base: introducción al contacto. Tackle seguro, ruck y juego colectivo. Progresión por bloques semanales.'
}, {
  title: 'TOMO 4 · M8 a M12 (Parte 2)',
  desc: 'Consolidación del juego infantil. Situaciones de partido y evaluación. Preparación para la etapa juvenil.'
}, {
  title: 'TOMO 5 · M13 (Parte 1)',
  desc: 'Transición al rugby estructurado. Scrum, line-out y ataque organizado. Bloques de 4 semanas con progresión.'
}, {
  title: 'TOMO 6 · M13 (Parte 2)',
  desc: 'Continuidad del sistema M13. Jugadas de pizarrón y evaluación anual. Mapa visual de las 52 semanas.'
}, {
  title: 'TOMO 7 · M14 (Parte 1)',
  desc: 'Transición II: fuerza y decisión táctica. Kicks estratégicos y defensa organizada. Sesiones listas semana a semana.'
}, {
  title: 'TOMO 8 · M14 (Parte 2)',
  desc: 'Consolidación del sistema M14. Partido estructurado y ajuste táctico. Cierre anual por posiciones.'
}, {
  title: 'TOMO 9 · M15 (Parte 1)',
  desc: 'Formación Juvenil: ataque avanzado. Encadenamiento de fases y salida de zona. Sistema de juego completo.'
}, {
  title: 'TOMO 10 · M15 (Parte 2)',
  desc: 'Alto rendimiento juvenil en M15. Jugadas de set piece y defensa en rush. Evaluación y proyección a M16.'
}, {
  title: 'TOMO 11 · M16 y M17 (Parte 1)',
  desc: 'Rugby de alto rendimiento amateur. Sistemas defensivos y ataque estructurado. Preparación para competencia oficial.'
}, {
  title: 'TOMO 12 · M16 y M17 (Parte 2)',
  desc: 'Consolidación del sistema M16/M17. Ajustes tácticos avanzados. Cierre de etapa formativa.'
}, {
  title: 'TOMO 13 · M19 y M23 (Parte 1)',
  desc: 'Rugby senior amateur y universitario. Sistema completo de juego por unidades. Planificación de pretemporada incluida.'
}, {
  title: 'TOMO 14 · M19 y M23 (Parte 2)',
  desc: 'Consolidación del sistema senior. Táctica de partido y ajuste en tiempo real. El sistema más completo del mercado.'
}];
export function TomosGrid() {
  return <section className="bg-white py-20 px-4" data-id="element-287">
      <div className="max-w-6xl mx-auto" data-id="element-288">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-289">
          {tomos.map((tomo, i) => <div key={i} className="border-2 border-[#39FF14] rounded-xl p-6 hover:shadow-[0_0_15px_rgba(57,255,20,0.2)] transition-shadow bg-white flex gap-4" data-id="element-290">
              <div className="text-3xl" data-id="element-291">🏉</div>
              <div data-id="element-292">
                <h4 className="font-bold text-lg text-gray-900 mb-2" data-id="element-293">
                  {tomo.title}
                </h4>
                <p className="text-gray-600 leading-relaxed" data-id="element-294">{tomo.desc}</p>
              </div>
            </div>)}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center bg-gray-50 p-8 rounded-2xl border border-gray-200" data-id="element-295">
          <div className="flex flex-col items-center gap-3" data-id="element-296">
            <Edit3 className="text-[#00CC00]" size={32} data-id="element-297" />
            <span className="font-bold text-gray-900" data-id="element-298">
              Sesiones listas por semana y bloque
            </span>
          </div>
          <div className="flex flex-col items-center gap-3" data-id="element-299">
            <Zap className="text-[#00CC00]" size={32} data-id="element-300" />
            <span className="font-bold text-gray-900" data-id="element-301">
              Sistema "Abrí y Entrenás"
            </span>
          </div>
          <div className="flex flex-col items-center gap-3" data-id="element-302">
            <FileText className="text-[#00CC00]" size={32} data-id="element-303" />
            <span className="font-bold text-gray-900" data-id="element-304">
              Fichas listas para imprimir
            </span>
          </div>
          <div className="flex flex-col items-center gap-3" data-id="element-305">
            <MapPin className="text-[#00CC00]" size={32} data-id="element-306" />
            <span className="font-bold text-gray-900" data-id="element-307">
              Contenido 100% adaptado al rugby argentino
            </span>
          </div>
        </div>
      </div>
    </section>;
}